import React, { useState } from "react";
import { useHistory, Link } from "react-router-dom";
import axios from "axios";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  CardFooter,
  Label,
  Form,
  FormGroup,
  Input,
  Col,
  Alert,
  Spinner,
  InputGroup,
  InputGroupText
} from "reactstrap";

import { Enviroments } from "../enviroments/enviroments";
import logoGreen from "assets/img/automaproa.PNG";
import InstallAppBanner from "components/InstallAppBanner/InstallAppBanner";
import LoginModal from "components/LoginModal/LoginModal";
// import ForgotPasswordModal from "components/ForgotPasswordModal/ForgotPasswordModal";

function Login() {
  const history = useHistory();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const canSubmit =
    email.trim() !== "" && password.trim() !== "" && !isSubmitting;

  const apiLG = Enviroments.API_URL_LOTOGREEN; // ex.: https://lotogreen.bet.br/
  const apiIA = Enviroments.API_URL_IA;        // ex.: http://localhost:3005/

  function extractErr(err) {
    const data = err?.response?.data;
    if (!data) return "Falha de rede. Tente novamente.";
    if (data.message) return data.message;
    if (data.errors) {
      // LG costuma mandar { errors: { email: ['...'] } }
      const first = Object.values(data.errors).flat()?.[0];
      if (first) return String(first);
    }
    if (typeof data === "string") return data;
    return "Usuário ou senha inválidos.";
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError(null);

    if (!canSubmit) {
      setError("Preencha e-mail e senha para continuar.");
      return;
    }

    setIsSubmitting(true);

    try {
      // 1) LOGIN na Cactus API (nova integração)
      // Endpoint: POST /api/auth/login
      // Body: { email, password }
      // Headers: X-Brand-Slug: esportiva
      const loginPayload = { email, password };
      const lgLogin = await axios.post(`${apiLG}api/auth/login`, loginPayload, {
        headers: { "X-Brand-Slug": "esportiva" }
      });

      const lgToken = lgLogin?.data?.access_token;
      const lgExpiresIn = lgLogin?.data?.expires_in || 0;
      const cookieKey = lgLogin?.data?.cookie_key; // Novo campo obrigatório para depósitos/jogos

      if (!lgToken) throw new Error("Falha ao autenticar na Plataforma.");

      // 2) Perfil do Usuário (Cactus API)
      // Endpoint: GET /api/auth/user
      // Headers: Authorization, X-Brand-Slug
      const meResp = await axios.get(`${apiLG}api/auth/user`, {
        headers: {
          Authorization: `Bearer ${lgToken}`,
          "X-Brand-Slug": "esportiva"
        }
      });
      const profile = meResp?.data || {};

      // 3) BRIDGE no seu backend – emite JWT interno e sincroniza usuário
      const bridgeResp = await axios.post(`${apiIA}auth/bridge`, {
        access_token: lgToken,
        profile
      });

      // ---- Persistência local ----
      // token interno
      const internalToken = bridgeResp?.data?.token || "";
      const internalExpiresIn = bridgeResp?.data?.expires_in || 0;
      const internalExpirationDate = bridgeResp?.data?.expirationDate || "";

      // token da LG/Cactus
      localStorage.setItem("apiToken", lgToken);
      localStorage.setItem("casinoToken", lgToken);
      if (cookieKey) localStorage.setItem("cookieKey", cookieKey); // Guardando cookie_key
      localStorage.setItem("casinoExpiresIn", String(lgExpiresIn));
      localStorage.setItem(
        "casinoExpiresAt",
        lgExpiresIn ? new Date(Date.now() + lgExpiresIn * 1000).toISOString() : ""
      );

      // token interno
      localStorage.setItem("internalToken", internalToken);
      localStorage.setItem("expires", String(internalExpiresIn));
      localStorage.setItem("expirationDate", internalExpirationDate || "");

      // dados do usuário (retornados do bridge)
      const user = bridgeResp?.data?.user || {};
      localStorage.setItem("userId", String(user.id || ""));
      localStorage.setItem("email", user.email || email);
      localStorage.setItem("name", user.name || profile.name || "");
      localStorage.setItem(
        "cpf",
        user.cpf || profile?.document?.number?.replace(/\D/g, "") || ""
      );
      localStorage.setItem("phone", user.phone || profile.phone || "");
      localStorage.setItem("role", user.role || "user");

      // assinatura (se vier do bridge)
      if (user.subscription_status)
        localStorage.setItem("subscription_status", user.subscription_status);
      if (user.subscription_ends_at)
        localStorage.setItem("subscription_ends_at", user.subscription_ends_at);

      history.push("/admin/history-aviator");
    } catch (err) {
      console.error("Erro no login:", err?.response?.data || err.message);
      setError(extractErr(err));
      setIsSubmitting(false);
    }
  }

  return (
    <div style={{ minHeight: "100vh", position: "relative" }}>
      <InstallAppBanner />
      <LoginModal />

      <Col className="ml-auto mr-auto col-md-6 col-lg-4">
        <Card className="shadow-lg border-0 mt-4">
          <Form onSubmit={handleSubmit} noValidate>
            <CardHeader className="pb-0">
              <CardTitle tag="h3" className="mb-2">
                Login
              </CardTitle>
            </CardHeader>

            <CardBody>
              <div className="d-flex justify-content-center mb-3">
                <img
                  src={logoGreen}
                  alt="Logotipo Automapro Aviator"
                  width={96}
                  height={96}
                />
              </div>

              {error && (
                <Alert color="danger" className="py-2 mb-3">
                  {error}
                </Alert>
              )}

              <FormGroup className="mb-3">
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  aria-label="Email"
                  bsSize="lg"
                  placeholder="seuemail@dominio.com"
                  type="email"
                  autoComplete="username"
                  autoFocus
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </FormGroup>

              <FormGroup className="mb-2">
                <Label htmlFor="password">Senha</Label>
                <InputGroup size="lg">
                  <Input
                    id="password"
                    aria-label="Senha"
                    placeholder="Sua senha"
                    type={showPassword ? "text" : "password"}
                    autoComplete="current-password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <InputGroupText
                    role="button"
                    onClick={() => setShowPassword((v) => !v)}
                    title={showPassword ? "Ocultar senha" : "Mostrar senha"}
                    style={{ cursor: "pointer" }}
                  >
                    {showPassword ? "🙈" : "👁️"}
                  </InputGroupText>
                </InputGroup>
              </FormGroup>

              <div className="d-flex justify-content-between mb-3">
                <a 
                  href="https://go.aff.esportiva.bet/bffv8o29" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="small"
                >
                  Cadastre-se
                </a>
                <a 
                  href="https://go.aff.esportiva.bet/bffv8o29" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="small"
                >
                  Esqueci minha senha
                </a>
              </div>
            </CardBody>

            <CardFooter className="d-grid gap-2">
              <Button
                color="primary"
                className="btn-fill"
                size="lg"
                type="submit"
                disabled={!canSubmit}
              >
                {isSubmitting ? (
                  <>
                    <Spinner size="sm" className="me-2" /> Entrando...
                  </>
                ) : (
                  "Login"
                )}
              </Button>
            </CardFooter>
          </Form>
        </Card>
      </Col>

      <div
        className="position-absolute"
        target="_blank"
        rel="noopener noreferrer"
        style={{ fontSize: 50, bottom: 55, right: 20, color: "green" }}
      >
        <i
          className="fab fa-whatsapp"
          onClick={() =>
            window.open(
              "https://wa.me/+5511971522258?text=Preciso de ajuda automapro aviator(ref: tela login)."
            )
          }
        />
      </div>
    </div>
  );
}

export default Login;
